import React from 'react';
import PropTypes from 'prop-types';
import { pureRender } from 'epic-alt-utils/index';
import NavActions from '../../actions';
import debounce from 'lodash.debounce';

@pureRender
export default class DividerLine extends React.Component {
    constructor(props) {
        super(props);

        this.toggleTabletMenuDebounce = debounce(this.toggleTabletMenu.bind(this), 10);
    }

    componentDidUpdate() {
        if (!this.context.isTablet) {
            NavActions.tabletNavActive.defer(false);
        }
    }

    static propTypes = {
        isActive: PropTypes.bool,
        searchActive: PropTypes.bool,
        hideTabletHamburger: PropTypes.bool
    };

    static contextTypes = {
        isTablet: PropTypes.bool
    };

    toggleTabletMenu() {
        if (!this.props.isActive && this.context.isTablet) {
            NavActions.tabletNavActive(true);
            NavActions.mobileNavActive(false);
            NavActions.mobileNavActiveLinks(false);
        } else {
            NavActions.tabletNavActive(false);
            NavActions.mobileNavActiveLinks(false);
        }

        //Reset all other clickable items
        NavActions.searchActive(false);
        NavActions.egNavActive(false);
        NavActions.mobileActiveLinkIndex(null);
    }

    render() {
        const active = this.props.isActive;
        const searchActive = this.props.searchActive;
        const hide = this.props.hideTabletHamburger;

        return (
            <div
                role="button"
                tabIndex="0"
                id="navLine"
                className={`nav-line ${active ? 'active rightnav-bg-color' : ''} ${searchActive ? 'search-active' : ''} ${hide ? 'hidden' : ''}`}
                onClick={this.toggleTabletMenuDebounce}>
                <span className="lines text-color-bg text-color-before-after" />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/scripts/components/dividerLine/DividerLine.js